<div class="card profile-selector-card">
    <div class="card-body profile-category-selector-container d-flex flex-column flex-md-row">
        <label class="flex-grow-1 d-flex align-items-center justify-content-center gap-3 cursor-pointer user-select-none fw-bold"
            [class.active]="selectedCategory === PROFILE_CATEGORY.GENERAL"
            [for]="PROFILE_CATEGORY.GENERAL">
            <input class="d-none" type="radio" kendoRadioButton size="large"
                [id]="PROFILE_CATEGORY.GENERAL" 
                name="profileCategory" 
                [value]="PROFILE_CATEGORY.GENERAL" 
                [(ngModel)]="selectedCategory"
                (ngModelChange)="categoryChangeHandler()"
            />
            <span>{{'myProfile.category.general' | translate}}</span>
        </label>

        <label class="flex-grow-1 d-flex align-items-center justify-content-center gap-3 cursor-pointer user-select-none fw-bold"
            [class.active]="selectedCategory === PROFILE_CATEGORY.ADDRESSES"
            [for]="PROFILE_CATEGORY.ADDRESSES">
            <input class="d-none" type="radio" kendoRadioButton size="large" 
                [id]="PROFILE_CATEGORY.ADDRESSES"
                name="profileCategory" 
                [value]="PROFILE_CATEGORY.ADDRESSES" 
                [(ngModel)]="selectedCategory"
                (ngModelChange)="categoryChangeHandler()"
            />
            <span>{{'myProfile.category.addresses' | translate}}</span>
        </label>

        <label class="flex-grow-1 d-flex align-items-center justify-content-center gap-3 cursor-pointer user-select-none fw-bold"
            [class.active]="selectedCategory === PROFILE_CATEGORY.BANK_ACCOUNTS"
            [for]="PROFILE_CATEGORY.BANK_ACCOUNTS">
            <input class="d-none" type="radio" kendoRadioButton size="large" 
                [id]="PROFILE_CATEGORY.BANK_ACCOUNTS"
                name="profileCategory" 
                [value]="PROFILE_CATEGORY.BANK_ACCOUNTS" 
                [(ngModel)]="selectedCategory"
                (ngModelChange)="categoryChangeHandler()"
            />
            <span>{{'myProfile.category.bankAccounts' | translate}}</span>
        </label>
    </div>
</div>